// import React, { useState } from "react";
// import { Card, Modal, Button } from "antd";

// const acceleratorsData = {
//   DevXOps_Accelerators: [
//     {
//       name: "Service Mesh",
//       description:
//         "A dedicated layer for secure, resilient & observable microservice communications",
//       capabilities: [
//         "Implementation on microservice architectures",
//         "Traffic Management",
//         "Circuit Breaking",
//         "Service Discovery",
//         "Observability",
//       ],
//     },
//     {
//       name: "Policy as a Code Mesh",
//       description:
//         "Use of rules to define and manage standard rules across Kubernetes infrastructure",
//       capabilities: [
//         "Standardize policy management",
//         "Drive in efficiency and speed",
//         "Infrastructure policies and rules",
//         "Compliance and Auditing",
//       ],
//     },
//     {
//       name: "DataOps Accelerator",
//       description: "Data Platform Automation to fasten Data Life Cycle Process",
//       capabilities: [
//         "Data Platform Infrastructure Automation",
//         "Data Pipeline Automation",
//         "Data Security Enhancement",
//         "Identity & Governance",
//         "User Friendly Interface",
//       ],
//     },
//     {
//       name: "ML Monitoring Accelerator",
//       description:
//         "MLOps Monitoring Solution for Model Governance & Management",
//       capabilities: [
//         "Models' Performance Metrics solution",
//         "Infrastructure Governance for Kernel",
//         "Model Drift Monitoring with alert management",
//         "ML Pipeline Quick Health Status & Checks",
//         "Easy steps to Monitor Data, Model & Predictions",
//       ],
//     },
//     {
//       name: "Azure Data Backup Accelerator",
//       description:
//         "One step solution for Data Backup throughout Data Life Cycle",
//       capabilities: [
//         "Standardize policy management",
//         "Drive in efficiency and speed",
//         "Infrastructure policies and rules",
//         "Compliance and Auditing",
//       ],
//     },
//     {
//       name: "FinOps on Containers",
//       description:
//         "Operational practice of managing financial implications of containers and public cloud usage",
//       capabilities: [
//         "Adopting an ownership model of resource usage",
//         "Cost Optimization",
//         "Clean up unused resources",
//         "Leverage efficient purchase options",
//       ],
//     },
//     {
//       name: "IaC",
//       description: "Centralized & Modularized IaC solution",
//       capabilities: [
//         "In-house developed app for centralized infra deployment and management",
//         "In-house developed Terraform module library",
//         "Reusable templates and pipelines",
//       ],
//     },
//     {
//       name: "DevSecOps",
//       description: "Reusable templatized process for setup and configuration",
//       capabilities: [
//         "DevSecOps Architecture for enterprise implementation",
//         "Azure DevOps Pipeline templates",
//         "Predefined Terraform and Ansible scripts",
//         "Centralized report dashboard",
//         "Predefined and explored list of 100+ DevSecOps tools",
//       ],
//     },
//     {
//       name: "DevTestOps",
//       description: "Reusable templatized process for setup and configuration",
//       capabilities: [
//         "Reusable Enterprise architecture",
//         "Reusable templates for pipeline creation",
//         "Centralized Dashboards",
//         "Process setup documentation",
//       ],
//     },
//   ],
// };

// // Icon mapping for each accelerator
// const getAcceleratorIcon = (name) => {
//   const icons = {
//     "Service Mesh": "🔗",
//     "Policy as a Code Mesh": "📋",
//     "DataOps Accelerator": "📊",
//     "ML Monitoring Accelerator": "🤖",
//     "Azure Data Backup Accelerator": "💾",
//     "FinOps on Containers": "💰",
//     IaC: "🏗️",
//     DevSecOps: "🔒",
//     DevTestOps: "🧪",
//   };
//   return icons[name] || "⚙️";
// };

// const Accelerators = ({
//   acceleratorData = acceleratorsData.DevXOps_Accelerators,
// }) => {
//   const [open, setOpen] = useState(false);
//   const [selectedAccelerator, setSelectedAccelerator] = useState(null);

//   const handleCardClick = (accelerator) => {
//     setSelectedAccelerator(accelerator);
//     setOpen(true);
//   };

//   return (
//     <div>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 px-16 py-8">
//         {acceleratorData?.map((accelerator, index) => (
//           <Card
//             key={index}
//             hoverable
//             variant="borderless"
//             className="text-center h-52 flex flex-col items-center justify-center custom-card"
//             styles={{
//               body: {
//                 justifyItems: "center",
//               },
//             }}
//             onClick={() => handleCardClick(accelerator)}
//           >
//             {/* <div className="w-20 h-20 flex items-center justify-center mb-2"></div> */}
//             <h3 className="text-lg font-medium">{accelerator.name}</h3>
//             <h3 className="text-slate-400 text-xs ">
//               {accelerator.description}
//             </h3>
//             <ul className="list-disc list-inside space-y-2">
//               {selectedAccelerator?.capabilities.map((capability, idx) => (
//                 <li key={idx} className="text-slate-600">
//                   {capability}
//                 </li>
//               ))}
//             </ul>
//           </Card>
//         ))}
//       </div>

//       <Modal
//         title={selectedAccelerator?.name}
//         width="70%"
//         open={open}
//         style={{ top: "20px" }}
//         onOk={() => setOpen(false)}
//         onCancel={() => setOpen(false)}
//         footer={[
//           <Button
//             className="modal-button"
//             key="back"
//             onClick={() => setOpen(false)}
//             style={{ color: "red", borderColor: "red" }}
//           >
//             Close
//           </Button>,
//         ]}
//       >
//         <div className="px-8 py-6">
//           <div className="mb-4">
//             <h4 className="text-base font-semibold mb-2">Description:</h4>
//             <p className="text-slate-600">{selectedAccelerator?.description}</p>
//           </div>

//           <div>
//             <h4 className="text-base font-semibold mb-3">Capabilities:</h4>
//             <ul className="list-disc list-inside space-y-2">
//               {selectedAccelerator?.capabilities.map((capability, idx) => (
//                 <li key={idx} className="text-slate-600">
//                   {capability}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default Accelerators;

import React, { useState } from "react";
import { Card, Modal, Button } from "antd";

const acceleratorsData = {
  DevXOps_Accelerators: [
    {
      name: "Service Mesh",
      description:
        "A dedicated layer for secure, resilient & observable microservice communications",
      capabilities: [
        "Implementation on microservice architectures",
        "Traffic Management",
        "Circuit Breaking",
        "Service Discovery",
        "Observability",
      ],
    },
    {
      name: "Policy as a Code Mesh",
      description:
        "Use of rules to define and manage standard rules across Kubernetes infrastructure",
      capabilities: [
        "Standardize policy management",
        "Drive in efficiency and speed",
        "Infrastructure policies and rules",
        "Compliance and Auditing",
      ],
    },
    {
      name: "DataOps Accelerator",
      description: "Data Platform Automation to fasten Data Life Cycle Process",
      capabilities: [
        "Data Platform Infrastructure Automation",
        "Data Pipeline Automation",
        "Data Security Enhancement",
        "Identity & Governance",
        "User Friendly Interface",
      ],
    },
    {
      name: "ML Monitoring Accelerator",
      description:
        "MLOps Monitoring Solution for Model Governance & Management",
      capabilities: [
        "Models' Performance Metrics solution",
        "Infrastructure Governance for Kernel",
        "Model Drift Monitoring with alert management",
        "ML Pipeline Quick Health Status & Checks",
        "Easy steps to Monitor Data, Model & Predictions",
      ],
    },
    {
      name: "Azure Data Backup Accelerator",
      description:
        "One step solution for Data Backup throughout Data Life Cycle",
      capabilities: [
        "Standardize policy management",
        "Drive in efficiency and speed",
        "Infrastructure policies and rules",
        "Compliance and Auditing",
      ],
    },
    {
      name: "FinOps on Containers",
      description:
        "Operational practice of managing financial implications of containers and public cloud usage",
      capabilities: [
        "Adopting an ownership model of resource usage",
        "Cost Optimization",
        "Clean up unused resources",
        "Leverage efficient purchase options",
      ],
    },
    {
      name: "IaC",
      description: "Centralized & Modularized IaC solution",
      capabilities: [
        "In-house developed app for centralized infra deployment and management",
        "In-house developed Terraform module library",
        "Reusable templates and pipelines",
      ],
    },
    {
      name: "DevSecOps",
      description: "Reusable templatized process for setup and configuration",
      capabilities: [
        "DevSecOps Architecture for enterprise implementation",
        "Azure DevOps Pipeline templates",
        "Predefined Terraform and Ansible scripts",
        "Centralized report dashboard",
        "Predefined and explored list of 100+ DevSecOps tools",
      ],
    },
    {
      name: "DevTestOps",
      description: "Reusable templatized process for setup and configuration",
      capabilities: [
        "Reusable Enterprise architecture",
        "Reusable templates for pipeline creation",
        "Centralized Dashboards",
        "Process setup documentation",
      ],
    },
  ],
};

const Accelerators = ({
  acceleratorData = acceleratorsData.DevXOps_Accelerators,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedAccelerator, setSelectedAccelerator] = useState(null);

  const handleCardClick = (accelerator) => {
    setSelectedAccelerator(accelerator);
    setOpen(true);
  };

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-16 py-8">
        {acceleratorData?.map((accelerator, index) => (
          <Card
            key={index}
            hoverable
            variant="borderless"
            className="overflow-hidden custom-card shadow-md h-72"
            bodyStyle={{
              padding: 0,
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
            // onClick={() => handleCardClick(accelerator)}
          >
            {/* Header Section with Gradient Background */}
            <div
              className="text-white px-6 py-2 text-center"
              style={{
                background: "linear-gradient(135deg,#013863 0%,  #005BA1 100%)",
                minHeight: "80px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h3 className="text-lg font-bold mb-1">{accelerator.name}</h3>
              <p className="text-xs font-medium leading-tight">
                {accelerator.description}
              </p>
            </div>

            {/* White Body Section with Bullet Points */}
            <div className="bg-white px-3 pt-2 flex-1 overflow-auto">
              <ul className="text-left text-sm text-gray-700 list-disc space-y-1.5">
                {accelerator.capabilities.map((capability, idx) => (
                  <li key={idx} className="leading-snug">
                    {capability}
                  </li>
                ))}
              </ul>
            </div>
          </Card>
        ))}
      </div>

      <Modal
        title={selectedAccelerator?.name}
        width="70%"
        open={open}
        style={{ top: "20px" }}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={[
          <Button
            className="modal-button"
            key="back"
            onClick={() => setOpen(false)}
            style={{ color: "red", borderColor: "red" }}
          >
            Close
          </Button>,
        ]}
      >
        <div className="px-8 py-6">
          <div className="mb-4">
            <h4 className="text-base font-semibold mb-2">Description:</h4>
            <p className="text-slate-600">{selectedAccelerator?.description}</p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-3">Capabilities:</h4>
            <ul className="list-disc list-inside space-y-2">
              {selectedAccelerator?.capabilities.map((capability, idx) => (
                <li key={idx} className="text-slate-600">
                  {capability}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Accelerators;
